// @flow
import type { Invite as ApiInvite } from 'api/invites';
import type { Action } from '../actions/invites';

export type Invite = {
  ...$Exact<ApiInvite>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: {
      ...Invite,
      isFetching: boolean
    }
  }
};

export default function invites(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'FETCH_INVITE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.inviteId]: {
            ...state.byId[action.inviteId],
            id: action.inviteId,
            isFetching: true
          }
        }
      };
    case 'FETCH_INVITE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invite.id]: {
            ...action.invite,
            isFetching: false
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
